import React from 'react';
import {
  getHeroContent, HeroImage, StoreLogo, SearchBar, CartBtn, TabContent, StoreFooter, getAddress, FaHeart, MdStore, MdLocalPhone, getTabLabel, InlineEditableText
} from './ThemeLayoutHelpers';

export default function GroveLayout({ p }) {
  const T = p.storeTheme || {};
  const primary = T.primaryColor || "#65a30d";
  const copy = getHeroContent(p, {
    eyebrow: "Grove • Nature Store",
    title: "Rooted in nature. Grown with care.",
    subtitle: "Organic, eco, and health products for a greener way of living.",
    primaryCta: "Shop Natural",
    secondaryCta: "Our Mission",
  });
  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: T.backgroundColor || "#f7fee7", fontFamily: T.fontFamily || "Nunito, sans-serif" }}>
      <div className="py-2 text-center text-[11px] font-bold uppercase tracking-[0.2em] text-white" style={{ backgroundColor: primary }}>{p.storeInfo?.businessCategory || p.storeInfo?.businessName}</div>
      <nav className="sticky top-0 z-40 border-b border-lime-200 bg-white/90 backdrop-blur-xl">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center gap-3">
          <StoreLogo storeInfo={p.storeInfo} border="border-2 border-lime-300" />
          <div>
            <p className="text-sm font-bold text-lime-900">{p.storeInfo?.businessName}</p>
            <p className="text-[10px] text-lime-600 font-semibold tracking-wide">{p.storeInfo?.businessCategory || (p.storefrontText?.storeInfo || "Store Info")}</p>
          </div>
          <SearchBar searchQuery={p.searchQuery} setSearchQuery={p.setSearchQuery} theme={T} className="flex-1 hidden md:block ml-3" />
          <div className="ml-auto flex items-center gap-2">
            <button onClick={p.handleGoToWishlist} className="relative p-2 rounded-full border border-lime-200 hover:bg-lime-50" style={{ color: primary }}>
              <FaHeart className="text-base" />
              {p.wishlistCount > 0 && <span className="absolute -top-1 -right-1 h-4 w-4 text-[9px] rounded-full bg-lime-600 text-white flex items-center justify-center">{p.wishlistCount}</span>}
            </button>
            <CartBtn p={p} />
            {p.userMenuElement}
          </div>
        </div>
      </nav>
      <section className="max-w-7xl mx-auto w-full px-4 pt-6">
        <div className="rounded-3xl overflow-hidden shadow-[0_18px_55px_rgba(101,163,13,0.28)]">
          <HeroImage p={p} themeId="grove" className="h-[340px] md:h-[420px]">
            <div className="absolute inset-0 bg-gradient-to-r from-lime-950/80 via-lime-900/40 to-transparent pointer-events-none" />
            <div className="absolute inset-0 px-8 md:px-12 flex flex-col justify-center">
              <span className="inline-block text-[10px] uppercase tracking-[0.26em] font-bold px-3 py-1 rounded-full bg-lime-500/25  mb-3 w-fit"><InlineEditableText p={p} field="heroEyebrow" value={copy.eyebrow}>{copy.eyebrow}</InlineEditableText></span>
              <h1 className="text-4xl md:text-5xl font-extrabold text-lime-400 leading-tight max-w-xl"><InlineEditableText p={p} field="heroTitle" value={copy.title}>{copy.title}</InlineEditableText></h1>
              <p className="mt-3 text-lime-400 max-w-md text-sm"><InlineEditableText p={p} field="heroSubtitle" value={copy.subtitle}>{copy.subtitle}</InlineEditableText></p>
              
              {/* Business Data Overlay */}
              <div className="mt-5 space-y-2 bg-black/10 backdrop-blur-sm p-4 rounded-2xl border border-white/10 w-fit">
                <div className="flex items-center gap-3">
                  <div className="h-8 w-8 rounded-full bg-lime-500/20 flex items-center justify-center text-lime-400">
                    <MdLocalPhone size={18} />
                  </div>
                  <span className="text-white font-bold tracking-wide">{p.storeInfo?.businessMobile || "Contact Us"}</span>
                </div>
                {getAddress(p.storeInfo) && (
                  <div className="flex items-center gap-3">
                    <div className="h-8 w-8 rounded-full bg-lime-500/20 flex items-center justify-center text-lime-300">
                      <MdStore size={18} />
                    </div>
                    <span className="text-white/80 text-xs font-medium leading-relaxed max-w-[240px]">{getAddress(p.storeInfo)}</span>
                  </div>
                )}
              </div>

              <div className="mt-6 flex gap-3">
                <button onClick={() => p.setActiveTab("products")} className="px-6 py-3 rounded-full text-sm font-bold text-white shadow-lg" style={{ backgroundColor: primary }}><InlineEditableText p={p} field="primaryCtaText" value={copy.primaryCta}>{copy.primaryCta}</InlineEditableText></button>
                <button onClick={() => p.setActiveTab("details")} className="px-6 py-3 rounded-full text-sm font-semibold text-white/70 border border-white/25"><InlineEditableText p={p} field="secondaryCtaText" value={copy.secondaryCta}>{copy.secondaryCta}</InlineEditableText></button>
              </div>
            </div>
          </HeroImage>
        </div>
      </section>
      <section className="max-w-7xl mx-auto w-full px-4 mt-5">
        <div className="rounded-2xl border border-lime-200 bg-white/80 p-1.5 flex gap-1.5 overflow-x-auto">
          {[["products", getTabLabel(p, "products")],["services", getTabLabel(p, "services")],["details", getTabLabel(p, "details")]].map(([k,l]) => (
            <button key={k} onClick={() => p.setActiveTab(k)} className="px-5 py-2 rounded-xl text-sm font-bold whitespace-nowrap transition" style={p.activeTab===k ? { backgroundColor: primary, color:"#fff" } : { color:"#365314" }}>{l}</button>
          ))}
        </div>
      </section>
      <section className="flex-1 max-w-7xl mx-auto w-full px-4 py-6"><TabContent p={p} /></section>
      <StoreFooter p={p} />
    </div>
  );
}

// ─── Tide ────────────────────────────────────────────────────────────────────